import { useEffect } from 'react';
import { Project } from 'library/types';
import { FormattedMessage } from 'react-intl';
import { renderAutoCompleteLocaleText } from 'utils';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import projectsActions from 'store/features/projects/actions';
import { selectProjects, selectProjectsIsEmpty } from 'store/features/projects/selector';
import { Autocomplete, Dialog, DialogContent, DialogTitle, TextField } from '@mui/material';

type ShowProductsProps = {
  open: boolean;
  handleClose: () => void;
  clickedProducts: Project[];
};

const ShowProducts = ({ open, clickedProducts, handleClose }: ShowProductsProps) => {
  // redux hooks
  const dispatch = useAppDispatch();
  const products = useAppSelector(selectProjects);
  const isEmptyProducts = useAppSelector(selectProjectsIsEmpty);

  // useEffect hooks
  useEffect(() => {
    if (!products.length && !isEmptyProducts) {
      dispatch(projectsActions.getProjects());
    }
  }, [products, isEmptyProducts, dispatch]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <FormattedMessage id="report.projects" defaultMessage="Ürünler" />
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <Autocomplete
          readOnly
          multiple
          options={products}
          value={clickedProducts}
          {...renderAutoCompleteLocaleText()}
          getOptionLabel={(option: Project) => option.title}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              slotProps={{
                input: {
                  ...params.InputProps,
                  disableUnderline: true,
                  endAdornment: null,
                },
              }}
            />
          )}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ShowProducts;
